import redirectPermanently from '@/components/Redirect/redirectPermanently';

const Redirect = () =>
  redirectPermanently(
    '/entrenamientos/official-agile-coach-certification-training'
  );

export default Redirect;
